import React, {Component} from 'react';
import {Link} from 'react-router-dom';
//CSS
import './BannerRRHH.css';

//img
import fotorrhh1 from '../../assets/img/rrhh/fotorrhh1.jpg';
import fotorrhh1Light from '../../assets/img/rrhh/fotorrhh1.webp';


class BannerRRHH extends Component {

    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {

    };

    render() {
        return (
            <div id="rrhh" className="banner-rrhh">
                <div className="texto-rrhh">
                    <div className="container-texto-rrhh">
                        <h3>
                            ¡Trabajá con nosotros!
                        </h3>
                        <p>
                            Te invitamos a ser parte de un equipo motivado, flexible y ágil que permita el
                            desarrollo personal y profesional. Con libertad para desafiarnos y aprender de manera
                            colaborativa, lleno de experiencias únicas.
                        </p>
                        <Link to={"/rrhh"}>Postulate</Link>
                    </div>
                </div>
                <div className="foto-rrhh">
                    <picture>
                        <source srcSet={fotorrhh1Light} type="image/webp"/>
                        <source srcSet={fotorrhh1} type="image/jpeg"/>
                        <img src={fotorrhh1} alt="imagen gente de rrhh"/>
                    </picture>
                </div>
            </div>
        );
    }
}


export default BannerRRHH;


// WEBPACK FOOTER //
// ./src/pages/RRHHPage/BannerRRHH.js